import { render, staticRenderFns } from "./OrgProvinces.vue?vue&type=template&id=786c0194&"
import script from "./OrgProvinces.vue?vue&type=script&lang=js&"
export * from "./OrgProvinces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports